import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';

@Injectable()
export class PdfToolsService {
  private fileSelectionSubject = new BehaviorSubject<any>(null);
  public fileSelectionData = this.fileSelectionSubject.asObservable();

  constructor() {
  }

  sendFileSelectionData(data: any) {
    const selectedFiles = (this.fileSelectionSubject.value) ? this.fileSelectionSubject.value : [];
    const fileIndex = selectedFiles.findIndex(x => x._id === data._id);
    if (fileIndex > -1) {
      selectedFiles.splice(fileIndex, 1);
    } else {
      selectedFiles.push(data);
    }
    this.fileSelectionSubject.next(selectedFiles);
    return true;
  }

  removeFileSelectionData(data: any) {
    const selectedFiles = (this.fileSelectionSubject.value) ? this.fileSelectionSubject.value : [];
    const fileIndex = selectedFiles.findIndex(x => x._id === data._id);
    if (fileIndex > -1) {
      selectedFiles.splice(fileIndex, 1);
    }
    this.fileSelectionSubject.next(selectedFiles);
    return true;
  }

  clearFileSelectionData() {
    this.fileSelectionSubject.next(null);
  }

  getFileSelectionData(): Observable<any> {
    return this.fileSelectionSubject.asObservable();
  }
}
